import { error, json } from "@sveltejs/kit";
import { promises } from "fs";
import path from "path";
import { W as WORKSPACE_DIR } from "../../../../../chunks/workspace.js";
function validatePath(requestPath) {
  const normalized = path.normalize(path.join(WORKSPACE_DIR, requestPath));
  if (!normalized.startsWith(WORKSPACE_DIR)) {
    throw error(403, "Access denied: Path outside workspace directory");
  }
  return normalized;
}
const POST = async ({ request }) => {
  try {
    const { oldPath, newPath } = await request.json();
    if (!oldPath || !newPath) {
      throw error(400, "Both oldPath and newPath are required");
    }
    const fullOldPath = validatePath(oldPath);
    const fullNewPath = validatePath(newPath);
    await promises.access(fullOldPath);
    try {
      await promises.access(fullNewPath);
      throw error(409, "Destination already exists");
    } catch (err) {
      if (err.code !== "ENOENT") {
        throw err;
      }
    }
    const destDir = path.dirname(fullNewPath);
    await promises.mkdir(destDir, { recursive: true });
    await promises.rename(fullOldPath, fullNewPath);
    return json({
      success: true,
      oldPath,
      newPath
    });
  } catch (err) {
    if (err instanceof Response) throw err;
    if (err.code === "ENOENT") {
      throw error(404, "Source file not found");
    }
    console.error("Error renaming file:", err);
    throw error(500, "Failed to rename file");
  }
};
export {
  POST
};
